import { render } from "./FormFacture.vue?vue&type=template&id=e4c5fcb8"
import script from "./FormFacture.vue?vue&type=script&lang=js"
export * from "./FormFacture.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__